import { ExpandableInfo } from '@/components/encounter/review/expandable-info';
import { useTranslation } from '@/contexts/i18n-context';
import { GetTreatmentPlanResponse } from '@/api/api.schemas';
import styles from './about-diagnosis-section.module.css';
type AboutDiagnosisSectionProps = Pick<
  GetTreatmentPlanResponse,
  'aboutYourDiagnosis' | 'diagnosisName' | 'counseling' | 'treatmentDetails'
> & { diagnosisName: string; className?: string };

const translationBase = 'visit.treatmentPlan.aboutYourDiagnosis';

export function AboutDiagnosisSection({
  aboutYourDiagnosis,
  diagnosisName,
  counseling,
  treatmentDetails,
  className,
}: AboutDiagnosisSectionProps) {
  const { t } = useTranslation();

  return (
    <ExpandableInfo title={t(`${translationBase}.title`)} className={className}>
      {aboutYourDiagnosis?.howDiagnosed && (
        <div className={styles.topicSection}>
          <p className="semibold">{t(`${translationBase}.howDiagnosed`, { diagnosisName })}</p>
          <p>{aboutYourDiagnosis.howDiagnosed}</p>
        </div>
      )}
      {counseling?.whoGets && (
        <div className={styles.topicSection}>
          <p className="semibold">{t(`${translationBase}.whoGets`, { diagnosisName })}</p>
          <p>{counseling.whoGets}</p>
        </div>
      )}
      {counseling?.whatCauses && (
        <div className={styles.topicSection}>
          <p className="semibold">{t(`${translationBase}.whatCauses`, { diagnosisName })}</p>
          <p>{counseling.whatCauses}</p>
        </div>
      )}
      {counseling?.usualCourse && (
        <div className={styles.topicSection}>
          <p className="semibold">{t(`${translationBase}.usualCourse`, { diagnosisName })}</p>
          <p>{counseling.usualCourse}</p>
        </div>
      )}
      {counseling?.makesWorse && (
        <div className={styles.topicSection}>
          <p className="semibold">{t(`${translationBase}.makesWorse`, { diagnosisName })}</p>
          <p>{counseling.makesWorse}</p>
        </div>
      )}
      {treatmentDetails && (
        <div className={styles.topicSection}>
          <p className="semibold">{t(`${translationBase}.howTreated`, { diagnosisName })}</p>
          <p>{treatmentDetails}</p>
        </div>
      )}
    </ExpandableInfo>
  );
}
